function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "bg_svg__b",
  x1: 0.87,
  x2: 0.13,
  y1: 0.03,
  y2: 0.86,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#182030",
  stopOpacity: 0.74
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#383d4a",
  stopOpacity: 0.74
})), React.createElement("linearGradient", {
  id: "bg_svg__c",
  x1: 0.91,
  x2: 0.15,
  y1: 0.27,
  y2: 0.33,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#0c1017",
  stopOpacity: 0.25
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#3b3e48",
  stopOpacity: 0.25
})), React.createElement("linearGradient", {
  id: "bg_svg__d",
  x1: 0.88,
  x2: 0.16,
  y1: 0.21,
  y2: 0.92,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#1b2026",
  stopOpacity: 0.55
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#373c43",
  stopOpacity: 0.24
})), React.createElement("clipPath", {
  id: "bg_svg__a"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h1920v700H0z",
  "data-name": "Rectangle 2"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#bg_svg__a)",
  "data-name": "Mask Group 1"
}, React.createElement("path", {
  fill: "#292e38",
  d: "M0 0h1920v700H0z",
  "data-name": "Path 5"
}), React.createElement("path", {
  fill: "url(#bg_svg__b)",
  d: "M-32.03 405.08s263.77 395.65 599.14 84.78 444.17-108.8 595.37-145.07 243.04-150.73 318.4-350.44S-32.02-131.88-32.02-131.88z",
  "data-name": "Path 1",
  transform: "translate(-95 -83)"
}), React.createElement("path", {
  fill: "rgba(53,58,70,0.74)",
  d: "M-296.02 179.08s468.5 329.14 993.5 18.27 716.56-11.96 953.24-48.23 303.64-181.06 421.62-380.77S-296.02-357.88-296.02-357.88z",
  "data-name": "Path 3"
}), React.createElement("path", {
  fill: "url(#bg_svg__c)",
  d: "M-39.9 280s266.78-488.66 602.14-177.8 499.35-36.26 650.55 0 192.73 167.67 268.1 367.38S-32.03 595.81-32.03 595.81z",
  "data-name": "Path 4",
  transform: "translate(633 445)"
}), React.createElement("path", {
  fill: "url(#bg_svg__d)",
  d: "M-32.03 405.08S287.61 819.1 660.98 508.24 1175.62 392.27 1343.95 356s320.51-288.18 404.42-487.89-1780.4 0-1780.4 0z",
  "data-name": "Path 2",
  transform: "translate(-14 37)"
}));

var SvgBg = function SvgBg(props) {
  return React.createElement("svg", _extends({
    "data-name": "Group 1",
    viewBox: "0 0 1920 700"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,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";
export { SvgBg as ReactComponent };